import script from "./ProcesoAutoevaluacionUsuarioView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcesoAutoevaluacionUsuarioView.vue?vue&type=script&lang=ts&setup=true"

import "./ProcesoAutoevaluacionUsuarioView.vue?vue&type=style&index=0&id=1495b3a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1495b3a0"]])

export default __exports__